export default __webpack_public_path__ + "static/media/invoiceIcon.bde50b2b.svg";